import { globalEventBus } from '@/plugins/eventBus';

// ─── Event Payload Types ───────────────────────────────────────────────────────

export interface ConnectorSyncStartedPayload {
  connectorId: string;
  connectorType: string;
}

export interface ConnectorSyncCompletedPayload {
  connectorId: string;
  result: 'success' | 'error' | 'partial';
  filesProcessed: number;
}

export interface ConnectorNewFilesDetectedPayload {
  connectorId: string;
  count: number;
}

// ─── Event Name Constants ──────────────────────────────────────────────────────

const CONNECTOR_SYNC_STARTED = 'connector:sync-started' as const;
const CONNECTOR_SYNC_COMPLETED = 'connector:sync-completed' as const;
const CONNECTOR_NEW_FILES_DETECTED = 'connector:new-files-detected' as const;

// ─── Emit Helpers ──────────────────────────────────────────────────────────────

export function emitConnectorSyncStarted(
  connectorId: string,
  connectorType: string,
): void {
  globalEventBus.emit(CONNECTOR_SYNC_STARTED, { connectorId, connectorType } satisfies ConnectorSyncStartedPayload);
}

export function emitConnectorSyncCompleted(
  connectorId: string,
  result: ConnectorSyncCompletedPayload['result'],
  filesProcessed: number,
): void {
  globalEventBus.emit(CONNECTOR_SYNC_COMPLETED, { connectorId, result, filesProcessed } satisfies ConnectorSyncCompletedPayload);
}

export function emitNewFilesDetected(
  connectorId: string,
  count: number,
): void {
  globalEventBus.emit(CONNECTOR_NEW_FILES_DETECTED, { connectorId, count } satisfies ConnectorNewFilesDetectedPayload);
}

// ─── Subscribe Helpers ─────────────────────────────────────────────────────────

export function subscribeConnectorSyncStarted(
  cb: (payload: ConnectorSyncStartedPayload) => void,
): () => void {
  return globalEventBus.subscribe(CONNECTOR_SYNC_STARTED, (payload) =>
    cb(payload as ConnectorSyncStartedPayload),
  );
}

export function subscribeConnectorSyncCompleted(
  cb: (payload: ConnectorSyncCompletedPayload) => void,
): () => void {
  return globalEventBus.subscribe(CONNECTOR_SYNC_COMPLETED, (payload) =>
    cb(payload as ConnectorSyncCompletedPayload),
  );
}

export function subscribeNewFilesDetected(
  cb: (payload: ConnectorNewFilesDetectedPayload) => void,
): () => void {
  return globalEventBus.subscribe(CONNECTOR_NEW_FILES_DETECTED, (payload) =>
    cb(payload as ConnectorNewFilesDetectedPayload),
  );
}
